import {
  RESYNC_PLC_SECURITIES,
  RESYNC_PLC_SECURITIES_SUCCESSFUL,
  RESYNC_PLC_SECURITIES_FAILED,
} from './actionTypes';

const initialState = {
  resyncPlcSecuritiesError: null,
  resultResyncPlcSecurities: null,
  loadingResyncPlcSecurities: false,
};

const resyncPlcSecurities = (state = initialState, action) => {
  switch (action.type) {
    case RESYNC_PLC_SECURITIES:
      state = { ...state, loadingResyncPlcSecurities: true, resyncPlcSecuritiesError: null };
      break;
    case RESYNC_PLC_SECURITIES_SUCCESSFUL:
      state = {
        ...state,
        loadingResyncPlcSecurities: false,
        resultResyncPlcSecurities: action.payload,
        resyncPlcSecuritiesError: null,
      };
      break;
    case RESYNC_PLC_SECURITIES_FAILED:
      state = {
        ...state,
        resultResyncPlcSecurities: null,
        loadingResyncPlcSecurities: false,
        resyncPlcSecuritiesError: action.payload,
      };
      break;
    default:
      state = { ...state };
      break;
  }
  return state;
};

export default resyncPlcSecurities;
